/**
 * Display gating for the account administration (M-006, [F-028]): the
 * account list, the status of the installation ([AC-045]) and the account
 * journal ([NF-017]). Account and role administration is the admin role as
 * such, not an operation of the rights matrix ([F-027]) - which is why this
 * one asks a role and every other affordance asks `can`. The system account
 * administers accounts too ([F-031]). The server re-checks every route.
 */
type HasRole = (role: string) => boolean;

/** May see the administration's nav entries and pages. */
export function canManageUsers(hasRole: HasRole, isSystem = false): boolean {
  return isSystem || hasRole("admin");
}
